import { Layout } from 'antd';
import type { ApiError } from 'common/models';
import ErrorAlert from 'components/ErrorAlert/ErrorAlert';
import QueryErrorAlert from 'components/ErrorAlert/QueryErrorAlert';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import type { PropsWithChildren } from 'react';
import React from 'react';

interface Props {
  className?: string;
  error?: string | ApiError | null;
  onRetry?: () => void;
  isLoading?: boolean;
  topLevel?: boolean;
}

const { Content } = Layout;

const PageContent: React.FC<PropsWithChildren<Props>> = (props): React.ReactElement => {
  const { children, onRetry, error, className, isLoading, topLevel } = props;

  return (
    <Content className={`PageContent ${className} ${topLevel ? 'topLevel' : ''}`}>
      {error && (
        <>
          {typeof error === 'string' ? (
            <ErrorAlert errorCode={error} />
          ) : (
            <QueryErrorAlert error={error} onRetry={onRetry} />
          )}
        </>
      )}
      {isLoading ? <LoadingIndicator /> : children}
    </Content>
  );
};

export default PageContent;
